export default __webpack_public_path__ + "static/media/15-Priyanka-Joshi.3cb9d48c.png";